// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.morph-icon-container .morph-icon {
  height: 1em;
}
.morph-icon-container .morph-icon path {
  transition: color 200ms ease;
}
.morph-icon-container .morph-icon-hidden {
  display: none;
  font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/svg-morph/svg-morph.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAEQ;EAEI,4BAAA;AADZ;AAKI;EACI,aAAA;EACA,eAAA;AAHR","sourcesContent":[".morph-icon-container {\n    .morph-icon {\n        height: 1em;\n\n        path {\n            // Dynamically updated from JS\n            transition: color 200ms ease;\n        }\n    }\n    \n    .morph-icon-hidden {\n        display: none;\n        font-size: 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
